import { createGridLayout, createGridItem } from "../../../../store/global/gridlayout";
import { lensPath } from 'ramda';
export const artistStates = {

  artistDetailsFlag: false,  // Seems not using state.

  selectedArtistData: {
    artistOverview: null
  },

  artistGridLayout0: createGridLayout({
    layout: [
      createGridItem({
        x: 0,
        y: 0,
        w: 60,
        h: 15,
        i: 'related_contacts',
      }),
      createGridItem({
        x: 30,
        y: 15,
        w: 30,
        h: 10,
        i: 'notes',
      }),
      createGridItem({
        x: 0,
        y: 15,
        w: 30,
        h: 10,
        i: 'related_documents',
      }),
      createGridItem({
        x: 0,
        y: 25,
        w: 60,
        h: 5,
        i: 'additional_infos',
      }),
      createGridItem({
        x: 0,
        y: 30,
        w: 30,
        h: 22,
        i: 'doc_editor',
      }),
      createGridItem({
        x: 30,
        y: 30,
        w: 30,
        h: 11,
        i: 'responsible_agents',
      }),
      createGridItem({
        x: 30,
        y: 40,
        w: 30,
        h: 11,
        i: 'country_requs',
      }),
      createGridItem({
        x: 0,
        y: 52,
        w: 30,
        h: 13,
        i: 'url',
      }),
      createGridItem({
        x: 30,
        y: 52,
        w: 30,
        h: 13,
        i: 'accounting_infos',
      }),
      createGridItem({
        x: 0,
        y: 65,
        w: 60,
        h: 5,
        i: 'tab_title_artist_defaults',
      }),
      createGridItem({
        x: 0,
        y: 70,
        w: 30,
        h: 40,
        i: 'requirements_english',
      }),
      createGridItem({
        x: 30,
        y: 70,
        w: 30,
        h: 40,
        i: 'requirements_2nd_language',
      }),
      createGridItem({
        x: 0,
        y: 110,
        w: 60,
        h: 5,
        i: 'tab_title_additional_artist_defaults',
      }),
      createGridItem({
        x: 0,
        y: 115,
        w: 30,
        h: 35,
        i: 'additional_artist_defaults',
      }),
      createGridItem({
        x: 30,
        y: 115,
        w: 30,
        h: 35,
        i: 'tab_title_custom_fields',
      }),
    ]
  }),
  artistGridLayout1: createGridLayout({
    layout: [
      // createGridItem({
      //   x: 0,
      //   y: 150,
      //   w: 60,
      //   h: 5,
      //   i: 'menu_Booking',
      // }),
      createGridItem({
        x: 0,
        y: 155,
        w: 60,
        h: 30,
        i: 'bookings',
      }),
    ]
  }),
  artistGridLayout2: createGridLayout({
    layout: [
      // createGridItem({
      //   x: 0,
      //   y: 185,
      //   w: 60,
      //   h: 5,
      //   i: 'tab_title_ical_web_links',
      // }),
      createGridItem({
        x: 0,
        y: 190,
        w: 20,
        h: 10,
        i: 'info',
      }),
      createGridItem({
        x: 20,
        y: 190,
        w: 20,
        h: 10,
        i: 'external_calendars',
      }),
      createGridItem({
        x: 40,
        y: 190,
        w: 20,
        h: 10,
        i: 'rss_feeds',
      }),
      createGridItem({
        x: 0,
        y: 200,
        w: 30,
        h: 20,
        i: 'booking_status',
      }),
      createGridItem({
        x: 30,
        y: 200,
        w: 30,
        h: 20,
        i: 'app_section',
      }),
    ]
  }),
  artistGridLayout3: createGridLayout({
    layout: [
      // createGridItem({
      //   x: 0,
      //   y: 220,
      //   w: 60,
      //   h: 5,
      //   i: 'tab_title_artist_app_web_links',
      // }),
      createGridItem({
        x: 0,
        y: 225,
        w: 30,
        h: 20,
        i: 'booking_status',
      }),
      createGridItem({
        x: 30,
        y: 225,
        w: 30,
        h: 20,
        i: 'app_section',
      }),
    ]
  }),
  artistGridLayout4: createGridLayout({
    layout: [
      // createGridItem({
      //   x: 0,
      //   y: 245,
      //   w: 60,
      //   h: 5,
      //   i: 'tab_title_google_map',
      // }),
      createGridItem({
        x: 0,
        y: 250,
        w: 60,
        h: 30,
        i: 'tab_title_google_map',
      }),
    ]
  }),
  artistGridLayout5: createGridLayout({
    layout: [
      // createGridItem({
      //   x: 0,
      //   y: 280,
      //   w: 60,
      //   h: 5,
      //   i: 'playlist',
      // }),
      createGridItem({
        x: 0,
        y: 285,
        w: 60,
        h: 20,
        i: 'tab_title_tracks',
      }),
    ]
  }),

  // artistDetailsGridLayouts:
  //   [
      
  //     ,
  //     ,
  //     ,
  //   ],

  artistDetails: [],
}

export const artistOverviewLens = lensPath([
  'selectedArtistData', 'artistOverview'
]);

export const selectedArtistPath = ['selectedArtistData'];
export const artistOverviewPath = [...selectedArtistPath, 'artistOverview'];
export const artistDetailsPath = [...selectedArtistPath, 'artist'];
export const artistDetailsNotePath = [...artistDetailsPath, 'notes'];

export const contactRelationPath = [...selectedArtistPath, 'contact_relations'];
export const artistFilesPath = [...selectedArtistPath, 'files'];
export const relatedInfosPath = [...selectedArtistPath, 'related_infos'];
export const relatedUsersPath = [...selectedArtistPath, 'related_users'];
export const relatedCountriesPath = [...selectedArtistPath, 'related_countries'];
export const travelOptionsPath = [...selectedArtistPath, 'travel_options'];
export const artistCustomDataPath = [...selectedArtistPath, 'artist_custom_data'];
export const bookingsPath = [...selectedArtistPath, 'bookings'];
export const statusesPath = [...selectedArtistPath, 'statuses'];
export const artistBookingLocationsPath = [...selectedArtistPath, 'artist_booking_locations_arr'];
export const tracksPath = [...selectedArtistPath, 'tracks'];
export const external_linksPath = [...selectedArtistPath, 'external_links'];

export const monthsPath = [...selectedArtistPath, 'months'];
export const locationsPath = [...selectedArtistPath, 'locations'];
export const citiesPath = [...selectedArtistPath, 'cities'];
export const promotersPath = [...selectedArtistPath, 'promoters'];
export const partnersPath = [...selectedArtistPath, 'partners'];


export const artistDetailsLens = lensPath(artistDetailsPath);
export const artistDetailsNoteLens = lensPath(artistDetailsNotePath);
export const contactRelationLens = lensPath(contactRelationPath);
export const artistFilesLens = lensPath(artistFilesPath);
export const relatedInfosLens = lensPath(relatedInfosPath);
export const relatedUsersLens = lensPath(relatedUsersPath);
export const relatedCountriesLens = lensPath(relatedCountriesPath);
export const travelOptionsLens = lensPath(travelOptionsPath);
export const artistCustomDataLens = lensPath(artistCustomDataPath);
export const bookingsLens = lensPath(bookingsPath);
export const statusesLens = lensPath(statusesPath);
export const artistBookingLocationsLens = lensPath(artistBookingLocationsPath);
export const tracksLens = lensPath(tracksPath);
export const external_linksLens = lensPath(external_linksPath);

export const monthsLens = lensPath(monthsPath);
export const locationsLens = lensPath(locationsPath);
export const citiesLens = lensPath(citiesPath);
export const promotersLens = lensPath(promotersPath);
export const partnersLens = lensPath(partnersPath);